module.exports = __webpack_public_path__ + "static/iu-9f56fe334ef5dcd1c9a8bddb44f5904f.png";